<template>
  <!-- COL_NAMEのeditableがtrueかfalse可に応じて、以下のテンプレートの表示非表示を切り替えている。-->
  <!-- 切り替え処理は DestinationWorkList.vueのonCellClicked関数内で行っている。-->
  <div class="cell-summary-dialog">
    <vs-popup
      :title="popupTitle"
      :active.sync="showPopupByColumnKey"
      id="vs_edit_cell_popup_gkmg"
      class="pm-popup"
    >
      <!-- 船舶名をクリックした際に地図を表示するポップアップ popupColumnKeyがnameの場合は、displayTypeがplain-textなので、後のelse-if該当しないように、一番初めに記載している -->
      <div v-if="popupColumnKey === 'name'">
        <dialog-port-vessel
          :showPopup="showPopup"
          :taskId="popupTaskId"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :canEdit="canEdit"
          :vesselsData="vesselsData"
          @updateValue="updateValue"
        >
        </dialog-port-vessel>
      </div>

      <!-- COL_NAMEのdisplayTypeがprogressの場合の編集コンポーネントの描画。progressは特殊なので、特別に専用の編集コンポーネントを作成している。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'progress'
        "
      >
        <dialog-progress-input
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :getMasterList="getMasterList"
          :closePopup="closePopup"
          @updateValue="updateValue"
        >
        </dialog-progress-input>
      </div>

      <!-- COL_NAMEのdisplayTypeがplain-textの場合の編集コンポーネントの描画。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'plain-text'
        "
      >
        <dialog-text-and-number-input
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :closePopup="closePopup"
          inputType="text"
          @updateValue="updateValue"
        >
        </dialog-text-and-number-input>
      </div>

      <!-- COL_NAMEのdisplayTypeがplain-numberの場合の編集コンポーネントの描画。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'plain-number'
        "
      >
        <dialog-text-and-number-input
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :closePopup="closePopup"
          inputType="number"
          @updateValue="updateValue"
        >
        </dialog-text-and-number-input>
      </div>

      <!-- COL_NAMEのdisplayTypeがHH:mmの場合の編集コンポーネントの描画。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'HH:mm'
        "
      >
        <dialog-date-input
          :taskId="popupTaskId"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :closePopup="closePopup"
          @updateValue="updateValue"
        >
        </dialog-date-input>
      </div>

      <!-- COL_NAMEのdisplayTypeがmasterMapの場合の編集コンポーネントの描画。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'masterMap'
        "
      >
        <dialog-port-trees
          :taskId="popupTaskId"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :closePopup="closePopup"
          @updateValue="updateValue"
          :selectedTask="popupTask"
        >
        </dialog-port-trees>
      </div>

      <!-- COL_NAMEのdisplayTypeがvehicleの場合の編集コンポーネントの描画。vehicleは特殊なので、特別に専用の編集コンポーネントを作成している。 -->
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'vehicles'
        "
      >
        <dialog-vehicles-input
          :taskId="popupTaskId"
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :closePopup="closePopup"
          @updateValue="updateValue"
        >
        </dialog-vehicles-input>
      </div>

      <!-- COL_NAMEのdisplayTypeがbitの場合の編集コンポーネントの描画。bitは特殊なので、特別に専用の編集コンポーネントを作成している。 -->
      <div
        v-else-if="componentDisplayTypeForEachColumn[popupColumnKey] === 'bit'"
      >
        <dialog-bit-input
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :closePopup="closePopup"
          @updateValue="updateValue"
        >
        </dialog-bit-input>
      </div>
      <div
        v-else-if="
          componentDisplayTypeForEachColumn[popupColumnKey] === 'boardside_type'
        "
      >
        <dialog-boardside-type
          :columnKey="popupColumnKey"
          :valueMap="popupValueMap"
          :taskId="popupTaskId"
          :closePopup="closePopup"
          @updateValue="updateValue"
        >
        </dialog-boardside-type>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/*
 * 入出港予定一覧画面（白色ではなく黒色画面）で、各カラムごとのセル編集画面を呼び出すためのコンポーネント
 * @parent DestinationWorkList.vue
 * @props
 *      showPopup : String 説明
 *      clickX : ポップアップの表示位置を決めるために使う
 *      clickY : ポップアップの表示位置を決めるために使う
 *      popupTitle  : String セル編集画面で表示するカラム名
 *      popupTaskId : String 一覧画面で表示する一行のデータにふられたID
 *      popupColumnKey : String カラム名を特定するためのキーconst.jsのCOL_NAMEの中の、columnKey
 *      popupValueMap  : Object: セルに表示する値と表示に関連して必要な情報。
 */
import DialogProgressInput from "@/components/organisms/gkmg-port-master/DialogProgressInput";
import DialogTextAndNumberInput from "@/components/organisms/gkmg-port-master/DialogTextAndNumberInput";
import DialogDateInput from "@/components/organisms/gkmg-port-master/DialogDateInput";
import DialogPortTrees from "@/components/organisms/gkmg-port-master/DialogPortTrees";
import DialogBitInput from "@/components/organisms/gkmg-port-master/DialogBitInput";
import DialogVehiclesInput from "@/components/organisms/gkmg-port-master/DialogVehiclesInput";
import DialogPortVessel from "@/components/organisms/gkmg-port-master/DialogPortVessel";
import DialogBoardsideType from "@/components/organisms/gkmg-port-master/DialogBoardsideType";
import { COL_NAME } from "@/config/const";

import Vue from "vue";
import FireStoreService from "@/services/fireStoreService";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "gkmgPortMasterDestinationWork",
);
const { mapState: mapStateOfGkmgPortMaster } =
  createNamespacedHelpers("gkmgPortMaster");

export default {
  props: {
    showPopup: { type: Boolean, required: true },
    clickX: { type: Number, required: true },
    clickY: { type: Number, required: true },
    popupTitle: { type: String, required: true },
    popupTaskId: { type: String, required: true },
    popupTask: { type: Object, required: true },
    popupColumnKey: { type: String, required: true },
    popupValueMap: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
    vesselsData: {
      type: Array, // vesselsData は船舶マスタのデータを想定
      default: () => [],
    },
  },
  components: {
    DialogProgressInput,
    DialogTextAndNumberInput,
    DialogBitInput,
    DialogVehiclesInput,
    DialogPortVessel,
    DialogBoardsideType,
    DialogDateInput,
    DialogPortTrees,
  },
  data() {
    return {
      showPopupByColumnKey: false,
      componentDisplayTypeForEachColumn: {},
    };
  },
  watch: {
    showPopup() {
      if (this.showPopup === true) {
        this.showDialogByColumnKey();
      }
    },
    showPopupByColumnKey() {
      if (this.showPopupByColumnKey === false) {
        this.$emit("update:showPopup", false);
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: (state) => state.masterMap,
    }),
    ...mapStateOfGkmgPortMaster({
      selectedPort: (state) => state.selectedPort,
    }),
  },
  created() {
    COL_NAME.forEach((el) => {
      Object.assign(this.componentDisplayTypeForEachColumn, {
        [el.columnKey]: el.displayType,
      });
    });
  },
  methods: {
    ...mapActions(["updateFirestoreDocument"]),
    getMasterList(columnKey) {
      return Object.values(this.masterMap[columnKey]);
    },
    showDialogByColumnKey() {
      if (
        (this.popupColumnKey === "caution_note" &&
          (!this.popupValueMap.value ||
            this.popupValueMap.value.length === 0)) ||
        (this.popupColumnKey === "previous" &&
          this.popupValueMap.order_type != "3")
      ) {
        // 注意事項が無い場合はポップアップは出さない。オーダーがシフトのとき以外は前泊地ポップアップは出さない。
        this.$emit("update:showPopup", false);
        return;
      }

      const vsEditCellPopup = document.getElementById(
        "vs_edit_cell_popup_gkmg",
      );
      const vsPopup = vsEditCellPopup.querySelector("div.vs-popup");

      const popupDefaultWidth = Math.floor(
        (document.documentElement.clientWidth * 5) / 12,
      );
      const popupDefaultHeight = Math.floor(window.innerHeight / 2);

      vsPopup.style.position = "absolute";
      if (
        this.clickX + popupDefaultWidth <
        document.documentElement.clientWidth
      ) {
        vsPopup.style.left = this.clickX + "px";
      } else {
        vsPopup.style.left =
          document.documentElement.clientWidth - popupDefaultWidth - 30 + "px";
      }
      if (
        this.clickY + popupDefaultHeight <
        document.documentElement.clientHeight
      ) {
        vsPopup.style.top = this.clickY + 30 + "px";
      } else {
        vsPopup.style.top =
          document.documentElement.clientHeight -
          popupDefaultHeight -
          30 +
          "px";
      }
      vsPopup.style.width = popupDefaultWidth + "px";
      vsPopup.style.height = "";

      this.showPopupByColumnKey = true;
    },
    async updateValue(...args) {
      // 更新登録処理の本体。
      // enterprisePort x taskId x ( columnKey = value ) の指定方法で Firestoreの該当列に書き込んでいる。

      const [taskId, updateKeyValueMap, mode] = args; // 個々のダイアログからは共通的なフォーマットで受領する。

      let updateData = {
        enterprisePort: this.selectedPort,
        taskId: taskId,
        data: updateKeyValueMap,
        updateMode: mode ? mode.includes("update") : false,
        updateTimeStamp: mode ? mode.includes("updateTimeStamp") : false,
      };

      const originalUpdateKeyValueMap = {
        [this.popupColumnKey]: this.popupValueMap.itSelf,
        updated_at: null,
      };

      Vue.$log.debug("updateData", updateData);
      this.showPopupByColumnKey = false;
      this.$emit("updateGridCell", updateData);

      const isConnected = await FireStoreService.getIsConnectedToGkmgPmTasks(
        taskId,
      );

      if (isConnected) {
        this.updateFirestoreDocument(updateData);
      } else {
        setTimeout(() => {
          this.$vs.notify({
            title: "値の更新に失敗しました。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
            position: "top-center",
          });
          const recoveringData = {
            enterprisePort: this.selectedPort,
            taskId: taskId,
            data: originalUpdateKeyValueMap,
            updateMode: mode ? mode.includes("update") : false,
            updateTimeStamp: mode ? mode.includes("updateTimeStamp") : false,
          };
          setTimeout(() => {
            this.$emit("updateGridCell", recoveringData);
          }, 1200);
        }, 1200);
      }
    },
    closePopup() {
      this.showPopupByColumnKey = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-popup {
  user-select: none; /* 選択を禁止する */
  .vs-popup {
    background-color: #f0f0f0 !important;
  }
  header {
    h3 {
      text-align: center;
      background-color: $pm-white;
      width: 100%;
      position: relative;
      font-family: "Hiragino Kaku Gothic ProN";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      align-items: center;
      color: #4f4f4f;
    }
    i {
      border-radius: 2rem;
      border: 0.15rem solid $pm-black;
      font-weight: bold;
    }
    background-color: $pm-white;
  }
  .outer-area {
    padding: 1rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%;
  }
  .vs-popup--close {
    background-color: $pm-white !important;
    transform: translate(-10px, 10px);
    &:hover {
      transform: translate(-10px, 8px);
    }
  }
}
#vs_edit_cell_popup_gkmg {
  &:has(.pm-dialog-port-tree) {
    div.vs-popup > div.vs-popup--content {
      overflow: visible;
    }
  }
}
</style>
